<template>
  <div class="wrapper">
    <div class="form-item form-error-out" v-if="error">
      <div class="form-error">
        <div class="error-icon">
          <img src="@/assets/icon/error.png" alt="" />
        </div>
        <div class="error-message">
          <p v-html="errorMessage"></p>
        </div>
      </div>
    </div>
    <div class="form-item form-error-out" v-if="globalError">
      <div class="form-error">
        <div class="error-icon">
          <img src="@/assets/icon/error.png" alt="" />
        </div>
        <div class="error-message">
          <p v-html="globalErrorMessage"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus.js";
import Vue from "vue";
export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      error: false,
      uerror: false,
      isDisabled: false,
      errorMessage: "",
    };
  },
  methods: {
    //user redirect login
    onSubmit(code) {
      this.$insProgress.start();
      this.$cardApi
        .post(
          `/auth/login/upoint`,
          {
            code: code,
            redirectUrl: "https://bonus.nomin.mn/upoint",
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          if (response.data.status === 0) {
            this.$auth.setToken(response.data.token);
            this.$auth.setMe(response.data);
            this.$bonusApi
              // this.$axiosApi
              .post(
                `bonus-card/info/token`,
                // `card/info`,
                {
                  tokenId: response.data.token,
                  // cardHolderInfId: response.data.cardHolderInfId,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    "Accept-Language": "mn",
                  },
                }
              )
              .then((response) => {
                var result = response.data;
                this.$auth.removeCardInfo();
                this.$auth.setCardInfo(response.data);
                this.$auth.setShowQRTrue();
                if (result.status === 0) {
                  this.$router.push({ name: "homeDashboard" });

                  // if (result.isEmployee === 0) {
                  //   this.$router.push({ name: "transaction" });
                  // } else {
                  //   this.$router.push({ name: "homeDashboard" });
                  // }
                } else {
                  this.$auth.destroyToken();
                  this.$auth.removeMe();
                  this.$router.push({ name: "login" });
                }
              })
              .catch(() => {
                this.$auth.destroyToken();
                this.$auth.removeMe();
                this.$router.push({ name: "login" });
              });

            this.$insProgress.finish();
          } else {
            Vue.prototype.globalError = false;
            this.errorMessage = response.data.message;
            this.error = true;
            this.$insProgress.finish();
          }
        })
        .catch((error) => {
          this.error = true;
          this.errorMessage = error;
          Vue.prototype.globalError = false;
          this.$insProgress.finish();
        });
    },
  },
  created() {
    if (this.$route.query.code) {
      this.onSubmit(this.$route.query.code);
    } else {
      this.$auth.destroyToken();
      this.$auth.removeMe();
      this.$router.push({ name: "login" });
    }

    EventBus.$on("GLOBAL_ERROR", (data) => {
      if (data === "error") {
        Vue.prototype.globalError = true;
      }
    });
    this.username = this.$route.params.id;
    //check user logged in
    if (this.$auth.loggedIn()) {
      this.$router.push("profile");
    }
  },
};
</script>
